var textboxlookup = {
    init: function () {
        var tbl = document.querySelectorAll('.textboxlookup');

        if (tbl.length === 0) {
            // Check for existance of .textboxlookup and return if none on the page
            return;
        } else {
            Array.prototype.forEach.call(tbl, function (tblContainer) {
                var input = tblContainer.querySelector('.textboxlookup__input');
                var btn = tblContainer.querySelector('.textboxlookup__button');
                textboxlookup.handleInput(input, tblContainer);
                textboxlookup.handleButton(btn, tblContainer, input);
            });
        }
    },

    handleInput: function (input, tblContainer) {
        input.addEventListener('keypress', function (event) {
            textboxlookup.validate(event, input, tblContainer);
        });
    },

    handleButton: function (btn, tblContainer, input) {
        btn.addEventListener('click', function (event) {
            event.preventDefault();
            textboxlookup.postToLocation(event, input, tblContainer);
        });
    },


    validate: function (event, input, tblContainer) {
        var isValid = false;
        var keyed = event.keyCode || event.which || event.key;

        // Regex testing for aplha numeric inputs
        var regex = /^[\w\s]+$/;
        var isValid = regex.test(String.fromCharCode(keyed));

        if (!isValid) {
            event.preventDefault();
            return false;
        }

        if (event.keyCode === 13 || event.key === 'Enter') {
            event.preventDefault();
            if (isValid) {
                textboxlookup.postToLocation(event, input, tblContainer);
            }
        }
        return isValid;
    },

    postToLocation: function (event, input, tblContainer) {
        event.preventDefault();
        var url = '';

        //Using Window.location to redirect to url as the form post element is overriding the URL params
        if (input.value === '') {
            url = tblContainer.querySelector('meta[name="textboxlookup__urlWithoutReg"]').getAttribute('content');
            window.location = url;
        } else {
            var regInput = input.value.replace(/\s/g, '');
            var reg = encodeURIComponent(regInput);
            url = tblContainer.querySelector('meta[name="textboxlookup__urlWithReg"]').getAttribute('content');
            window.location = url + '?RegNumber=' + reg;
        }
    }
};

document.addEventListener('DOMContentLoaded', function () {
    textboxlookup.init();
});